/* eslint block-scoped-var: 0 */
(
    function ($) {
        'use strict';

        var Configurator = {
            $currentProduct: $('[data-product-item]'),

            $defaultColors: [
                'Kleur band',
                'blauw',
                'oranje',
                'groen',
                'geel',
                'rood',
                'zwart',
                'grijs',
                'wit'
            ],

            $emptyOptions: [
                'N.V.T.'
            ],

            arrayToSelectOptions: function (array) {
                var options = '';
                $.each(array, function (index, value) {
                    options += '<option>' + value + '</option>';
                });
                return options;
            },

            renderSelectField: function (element, array) {
                var target = this.$currentProduct.find(element);
                if (target && $(target).length > 0 && array) {
                    $(target).html(this.arrayToSelectOptions(array));
                }
            },

            renderFormValues: function (werklastItems, ratelItems, haakItems) {
                this.renderSelectField('[data-workload]', werklastItems || this.$emptyOptions);
                this.renderSelectField('[data-ratel]', ratelItems || this.$emptyOptions);
                this.renderSelectField('[data-haak]', haakItems || this.$emptyOptions);
            },

            onBandTypeChange: function (element) {
                this.$currentProduct = $(element.currentTarget).parents('[data-product-item]');

                var bandType = $(element.currentTarget).val();

                this.$currentProduct.find('[data-product-title]').html(bandType || 'Product toevoegen');

                var bagagegordelWerklastItems = [
                    'Werklast (kg)',
                    '25 mm 250 kg',
                    '25 mm 450 kg',
                    '35 mm 700 kg',
                    '50 mm 1000 kg'
                ];

                var bagagegordelRatelItems = [
                    'Ratel / Klemgesp',
                    'Klemgesp verzinkt',
                    'Klemgesp RVS',
                    'Klemgesp zwart'
                ];

                var spanbandWerklastItems = [
                    'Werklast',
                    '25 mm 800 kg',
                    '25 mm 1500 kg',
                    '35 mm 2000 kg',
                    '35 mm 3000 kg',
                    '50 mm 4000 kg',
                    '50 mm 5000 kg',
                    '75 mm 10.000 kg'
                ];

                var spanbandRatelItems = [
                    'Ratel / Klemgesp',
                    'Ratel verzinkt (standaard)',
                    'Ratel zwart',
                    'Ratel RVS',
                    'Ergoratel verzinkt',
                    'Blokratel verzinkt'
                ];

                var spanbandHaakItems = [
                    'Haken',
                    'Spitshaak verzinkt (standaard)',
                    'Spitshaak RVS',
                    'Spitshaak met klep',
                    'Euroclip',
                    'Klauwhaak verzinkt',
                    'Karabijnhaak',
                    'Platte Haak',
                    'Draaihaak',
                    'S-haak',
                    'D-ring',
                    'Lus (voor bout)'
                ];

                var hijsbandWerklastItems = [
                    'Werklast',
                    '1000 kg',
                    '2000 kg',
                    '3000 kg',
                    '4000 kg',
                    '5000 kg',
                    '6000 kg',
                    '7000 kg',
                    '8000 kg',
                    '9000 kg',
                    '10000 kg',
                    'Zwaarder (invullen bij opmerkingen)'
                ];

                var hijsbandHaakItems = [
                    'Haken',
                    'Hijshaak'
                ];


                switch (bandType) {
                case 'Bagagegordel':

                    this.renderFormValues(
                        bagagegordelWerklastItems,
                        bagagegordelRatelItems
                    );
                    break;

                case 'Spanband 1-delig':

                    this.renderFormValues(
                        spanbandWerklastItems,
                        spanbandRatelItems
                    );
                    break;

                case 'Spanband 2-delig':
                case 'Windseldeel':
                case 'Rateldeel':

                    this.renderFormValues(
                        spanbandWerklastItems,
                        spanbandRatelItems,
                        spanbandHaakItems
                    );
                    break;

                case 'Losse band':

                    this.renderFormValues(spanbandWerklastItems);
                    break;

                case 'Hijsband enkellaags met lus':
                case 'Hijsband dubbellaags met lus':

                    this.renderFormValues(
                        hijsbandWerklastItems,
                        null,
                        hijsbandHaakItems
                    );
                    break;

                case 'Hijsband eindloos':

                    this.renderFormValues(hijsbandWerklastItems);
                    break;

                case 'Bandsoort':
                default:

                    this.renderFormValues(bagagegordelWerklastItems);
                }

                this.renderSelectField('[data-color]', this.$defaultColors);
            },

            onAddProduct: function (element) {
                element.preventDefault();

                var clone = $('[data-product-item]:last').clone();
                clone.find('input').val('');
                clone.find('[data-product-title]').html('');
                clone.removeClass('collapsed');

                $('[data-product-item]').each(function () {
                    $(this).addClass('collapsed');
                    var title = $(this).find('[data-band_type ]').val();
                    $(this).find('[data-product-title]').html(title || 'Product toevoegen');
                });

                clone.appendTo('[data-product-wrapper]');

                this.setProductInputNames();
            },

            onRemoveProduct: function (element) {
                element.preventDefault();

                $(element.currentTarget).parents('[data-product-item]').remove();

                this.setProductInputNames();
            },

            onEditProduct: function (element) {
                element.preventDefault();

                $(element.currentTarget).parents('[data-product-item]').toggleClass('collapsed');
            },

            setProductInputNames: function () {
                $('[data-product-item]').each(function (rowIdx) {
                    $(this).find('[name^=products]').each(function () {
                        var name = $(this).attr('name');
                        name = name.replace(/^products\[([0-9]*)\]/, 'products[' + rowIdx + ']');
                        $(this).attr('name', name);
                    });

                    $(this).find('[name^=product_images]').each(function () {
                        var name = $(this).attr('name');
                        name = name.replace(/^product_images_([0-9]*)/, 'product_images_' + rowIdx);
                        $(this).attr('name', name);
                    });
                });
            }
        };

        $(document).on({
            change: $.proxy(Configurator, 'onBandTypeChange')
        }, '[data-band_type]');

        $(document).on({
            click: $.proxy(Configurator, 'onAddProduct')
        }, '[data-product-add]');

        $(document).on({
            click: $.proxy(Configurator, 'onRemoveProduct')
        }, '[data-product-remove]');

        $(document).on({
            click: $.proxy(Configurator, 'onEditProduct')
        }, '[data-product-edit]');
    }(jQuery)
);
